import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import AwardRegularIcon from '../../shared/icons/award-regular-icon';
import PiggyBankRegularIcon from '../../shared/icons/piggy-bank-regular-icon';

import { useAemContent } from '../../shared/hooks/hooks';

import { formatNaDisplayValue } from '../../shared/utils/format/format';

import { ProductData } from '../../shared/types/graphql-types';
import {
  AEM_CONTENT_IDS,
  AEM_CONTENT_PAGE_IDS
} from '../../shared/constants/cms';

import styles from './tire-life-warranty-info.scss';

interface TireLifeWarrantyInfoProps {
  milesPerDollar?: number;
  product?: ProductData;
  showTooltip?: boolean;
  warranty?: number;
}

function TireLifeWarrantyInfo(props: TireLifeWarrantyInfoProps) {
  const {
    milesPerDollar: milesPerDollarProp,
    product,
    showTooltip = false,
    warranty: warrantyProp
  } = props;
  const { milesPerDollar = milesPerDollarProp } =
    product?.recommendationData || {};
  const { mileage } = product?.recommendationData || product?.tdsData || {};
  const { median = 0, warranty = warrantyProp } = mileage || {};
  const actualPrice = product?.mapPrice?.value ?? product?.price?.value;
  const actualMilesPerDollar =
    milesPerDollar ?? Math.round(median / (actualPrice || 1));

  const { aemTooltipsContent } = useAemContent(
    AEM_CONTENT_PAGE_IDS.treadwellPdp
  );
  const milesPerDollarContent =
    aemTooltipsContent?.[AEM_CONTENT_IDS.milesPerDollar];

  return (
    <div
      className={styles['range-top-container']}
      data-testid="tire-life-warranty-info"
    >
      <div className={styles['item-container']}>
        <div className={styles['title']}>
          <AwardRegularIcon className={styles['icon']} />
          <Typography weight="bold">Tire Warranty</Typography>
        </div>
        <Typography className={styles['metric']}>
          {formatNaDisplayValue(warranty || product?.mileageWarranty, true)}
        </Typography>
      </div>
      <div className={styles['item-container']}>
        <div className={styles['title']}>
          <PiggyBankRegularIcon className={styles['icon']} />
          <Typography weight="bold">
            {milesPerDollarContent?.title || 'Miles per Dollar'}
          </Typography>
          {showTooltip && (
            <Tooltip
              className={styles['tooltip']}
              content={milesPerDollarContent?.tipText}
            />
          )}
        </div>
        <Typography className={styles['metric']}>
          {formatNaDisplayValue(actualMilesPerDollar)}
        </Typography>
      </div>
    </div>
  );
}

export default TireLifeWarrantyInfo;
